import React, { useContext } from 'react';
import { useNavigate } from 'react-router';

import styled from '@emotion/styled';

import useChangePassword from '../../../../hooks/dashboard/settings/useChangePassword';
import {
  ChangePasswordDataType,
  changePasswordInitialValues,
  ChangePasswordSchema,
} from '../../../../models/dashboard/settings/change-password';
import { DASHBOARD } from '../../../../routes/routeConstants';
import { FormSubmitButton } from '../../../Button/FormSubmitButton';
import { FormComponent } from '../../../FormCom/FormComponent';
import { HideableTextFormField } from '../../../FormCom/HideableTextFormField';
import ModalContainer from '../../ModalContainer';
import { ModalContext } from '../../ModalContext';
import PlainSuccessModal from '../../PlainSuccessModal';

const ChangePasswordModal = () => {
  const modalContext = useContext(ModalContext);
  const { changePassword, loading } = useChangePassword();
  const navigate = useNavigate();

  const successActionFn = () => {
    modalContext?.setShowModal(false);
    navigate(`/${DASHBOARD}`);
  };

  const onSubmit = (value: ChangePasswordDataType) => {
    changePassword(value);
  };

  return (
    <Container>
      <ModalContainer
        label='Change Password'
        successComponent={() => (
          <PlainSuccessModal
            successActionFn={successActionFn}
            description='Your password has been successfully changed.'
            btnLabel='Go to Dashboard'
            className='pink'
          />
        )}
        showSuccessComponent={modalContext?.showSuccessComponent}
      >
        <FormComponent
          initialValues={changePasswordInitialValues}
          schema={ChangePasswordSchema}
          onSubmit={onSubmit}
          className={'small-gap'}
        >
          <HideableTextFormField
            label='Current Password'
            name='oldPassword'
            id='oldPassword'
            type='password'
            placeholder='Enter your password'
          />
          <HideableTextFormField
            label='New Password'
            name='newPassword'
            id='newPassword'
            type='password'
            placeholder='Enter your password'
          />
          <HideableTextFormField
            label='Confirm New Password'
            name='confirmPassword'
            id='confirmPassword'
            type='password'
            placeholder='Enter your password'
          />
          <FormSubmitButton className='blue topMargin large' loading={loading}>
            Continue
          </FormSubmitButton>
        </FormComponent>
      </ModalContainer>
    </Container>
  );
};

export default ChangePasswordModal;

const Container = styled.div`
  flex-direction: column;
  gap: 12px;
  display: flex;
`;
